/*global Croppie:true*/

/**
 * TODO - Docs
 */
angular.module('b2bLoginApp.directives').directive('sdCroppy', ["$compile", function ($compile) {
    return {
        restrict: 'A',
        scope: {
            selectedPhoto: '=',
        },
        link: function (scope, element) {
            var cropper,
                imgTemplate = '<img class="selected-photo-img edited">',
                zoomDecreaseTpl = '<div class="icon-zoom-out" ng-click="zoomOut()"></div>',
                zoomIncreaseTpl = '<div class="icon-zoom-in" ng-click="zoomIn()"></div>'


            function initCroppie() {
                element.html(imgTemplate);
                cropper = new Croppie(element.find('img')[0], {
                    url: scope.selectedPhoto.url,
                    update: lazyUpdate,
                    viewport: {
                        width: element.width() - 70,
                        height: (element.width() - 70) / 1.5
                    },
                    boundary: {
                        width: element.width() - 30,
                        height: (element.width() - 30) / 1.5
                    },
                });
            }

            scope.zoomIn = function () {
                cropper.setZoom(cropper.get().zoom + 0.1);
            };

            scope.zoomOut = function () {
                cropper.setZoom(cropper.get().zoom - 0.1);
            };

            function initZoomControls() {
                var zoomDecreaseElement = angular.element(zoomDecreaseTpl),
                    zoomIncreaseElement = angular.element(zoomIncreaseTpl),
                    sliderWrapper = angular.element(element[0].getElementsByClassName('cr-slider-wrap')[0]);

                element.append(sliderWrapper);

                sliderWrapper.addClass('d-flex').addClass('justify-content-center').addClass('align-items-center');
                sliderWrapper.prepend(zoomDecreaseElement);
                sliderWrapper.append(zoomIncreaseElement);
                sliderWrapper.find('input').one('change', function () {

                    cropper.bind(scope.selectedPhoto)
                        .then(() => {
                            cropper.setZoom(0);
                        });
                    scope.$digest();
                });

                $compile(zoomDecreaseElement)(scope);
                $compile(zoomIncreaseElement)(scope);
            }

            function debounce(a, b, c) {
                var d;
                return function () {
                    var e = this, f = arguments, g = function () {
                        d = null, c || a.apply(e, f);
                    }, h = c && !d;
                    clearTimeout(d), d = setTimeout(g, b), h && a.apply(e, f);
                };
            }

            var lazyUpdate = debounce(function (crop) {
                cropper.result({
                    type: 'base64',
                    size: 'viewport'
                }).then(function (base64) {
                    scope.selectedPhoto.crop = crop;
                    scope.selectedPhoto.croppedPhoto = base64;
                });
            }, 100);

            initCroppie();
            initZoomControls();
        }
    };
}]);
